export const OOREDOO_PROMOCODE = 'OoredooPass'
export const OOREDOO_SCHEME_CODE_DEV = '5067'
export const OOREDOO_SCHEME_CODE_PROD = '5071'
